// src/routes/ProjectsPage.js
import React from "react";
import Navbar from "../components/Navbar";
import PageHero from "../components/PageHero";
import Projects from "../components/Projects";
import Footer from "../components/Footer";

const ProjectsPage = () => (
  <div>
    <Navbar />
    <PageHero label="Work" heading="Projects." sub="A showcase of what I've built." />
    <Projects title="All Projects" />
    <Footer />
  </div>
);

export default ProjectsPage;
